import http from '@/utils/http';

const baseUrl = '/rastreabilidade/saldo-producao';

export default {
    buscarSaldoProducaoGraficos(filtro) {
        let url = baseUrl + '/totalizador-graficos?codigoFazenda=' + filtro.textoBusca +
                            '&data-inicio=' + filtro.dataInicioPesquisa +
                            '&data-fim=' + filtro.dataFimPesquisa +
                            '&fazendasCertificadas=' + filtro.fazendasCertificadas;
        return http.get({
            url: url,
            lockScreen: false
        });
    }
};
